import type { SummaryStatistics } from '~/domain/statistics/summaryStatistics';

/** The statistics that are shown to the user; `count` is not one of them. */
export type SummaryStatKey = keyof Omit<SummaryStatistics, 'count'>;

/**
 * The label for each statistic, as a message id. Every readout (line
 * profile, region, structure intensity) takes its labels from here, so the
 * same statistic is always called the same thing; the standard deviation in
 * particular is "SD" everywhere. The order the labels appear in is up to each readout.
 */
export const SUMMARY_STAT_LABEL_IDS: Readonly<Record<SummaryStatKey, string>> =
    {
        min: 'stat.min',
        max: 'stat.max',
        mean: 'stat.mean',
        std: 'stat.sd',
    };
